<template>
  <div class="w1200 zhaogu-page">
    <div class="page-bar">
      <span class="back-btn" @click="goBack">← 返回</span>
    </div>
    <div class="page-title">帮扶中心实战超市</div>

    <div class="market-entry">
      <span class="entry-btn" @click="goMyPurchase">我的购买</span>
      <span class="entry-btn" @click="goMyOffering">我发布的</span>
      <span class="entry-btn" @click="goMySold">销售总览</span>
    </div>

    <div class="lottery">
      <span :class="chaoshi.preType == 0 ? 'active' : ''" @click="switchChaoshiLottery(0)">双色球</span>
      <span :class="chaoshi.preType == 1 ? 'active' : ''" @click="switchChaoshiLottery(1)">大乐透</span>
      <div class="msg">实体投注站帮扶中心</div>
    </div>

    <div class="sub">
      <div>
        <span>实战超市投注站战绩</span>
        <div class="msg">
          <span>实战超市方案价格+方案本金=实战总额</span>
          <span>1元=1缩币</span>
          <span>开奖当天18:30停止认购实战方案</span>
          <span>实战票当天20:00以后公示</span>
        </div>
      </div>
      <span class="btn">投注站申请帮扶</span>
    </div>

    <div class="tit">
      <div>
        <h3>{{ issueNumber }}{{ chaoshi.preType == 0 ? '双色球' : '大乐透' }}期实战团队方案汇总</h3>
        <div>
          <span @click="switchChaoshiPeriod(0)" :class="{ active: chaoshi.type == 0 }">最新期</span>
          <span @click="switchChaoshiPeriod(1)" :class="{ active: chaoshi.type == 1 }">上一期</span>
          <span @click="switchChaoshiPeriod(2)" :class="{ active: chaoshi.type == 2 }">下一期</span>
        </div>
      </div>
      <div class="btn">实战方案由专业团队出品</div>
    </div>

    <el-table v-loading="chaoshiLoading" :data="chaoshi_tableData" empty-text="暂无实战方案"
      :header-cell-style="{ 'textAlign': 'center' }" :cell-style="{ 'textAlign': 'center' }">
      <el-table-column type="index" label="排名" width="60"></el-table-column>
      <el-table-column label="实战团队" prop="teamName" show-overflow-tooltip></el-table-column>
      <el-table-column label="期数" prop="preNumber"></el-table-column>
      <el-table-column label="实战方案" align="center" width="200">
        <template slot-scope="scope">{{ scope.row.title || '-' }}</template>
      </el-table-column>
      <el-table-column label="上期实战盈亏状态" prop="plStatus"></el-table-column>
      <el-table-column label="缩币价格" align="center">
        <template slot-scope="scope">
          {{ scope.row.coin != null && scope.row.coin !== '' ? scope.row.coin + ' 缩币' : '-' }}
        </template>
      </el-table-column>
      <el-table-column label="认购状态" prop="buyStatus"></el-table-column>
      <el-table-column label="是否已购买" align="center">
        <template slot-scope="{ row: item }">
          <template v-if="item.selfPublished">--</template>
          <template v-else>
            <el-tag v-if="item.purchased" type="success" @click="chaoshiItemDownload(item)">下载</el-tag>
            <template v-else>
              <el-tag v-if="item.actions.isSoldOut" type="info">已售罄</el-tag>
              <el-tag v-else type="danger" @click="chaoshiItemBuy(item)">购买</el-tag>
            </template>
          </template>
        </template>
      </el-table-column>
    </el-table>

    <div class="tableMsg">目前开放双色球和大乐透，仅实体投注站可以认购</div>

    <div class="fenye">
      <span class="zhanwei"></span>
      <el-pagination v-if="chaoshi.total > 0" background layout="prev, pager, next" :total="chaoshi.total"
        :page-size="chaoshi.pageSize" :current-page="chaoshi.pageNum" @current-change="onChaoshiPage">
      </el-pagination>
      <span class="zhanwei"></span>
    </div>

    <!-- 实战方案购买确认弹窗 -->
    <el-dialog :title="buyDialog.title" :visible.sync="buyDialog.show" width="50%" :close-on-click-modal="false">
      <div v-if="buyDialog.row" class="buy-info">
        <div class="buy-row"><span class="buy-label">实战团队</span><span class="buy-value">{{ buyDialog.row.teamName || '-'
            }}</span></div>
        <div class="buy-row"><span class="buy-label">期数</span><span class="buy-value">{{ buyDialog.row.preNumber || '-'
            }}</span></div>
        <div class="buy-row"><span class="buy-label">实战方案</span><span class="buy-value">{{ buyDialog.row.title || '-'
            }}</span></div>
        <div class="buy-row"><span class="buy-label">缩币价格</span><span class="buy-value">{{ buyDialog.row.coin != null &&
          buyDialog.row.coin !== '' ? buyDialog.row.coin + ' 缩币' : '-' }}</span></div>
        <div class="buy-row"><span class="buy-label">认购状态</span><span class="buy-value">{{ buyDialog.row.buyStatus ||
            '-'
            }}</span></div>
        <div class="buy-row"><span class="buy-label">上期实战盈亏状态</span><span class="buy-value">{{ buyDialog.row.plStatus ||
            '-'
            }}</span></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="buyDialog.show = false">取消</el-button>
        <el-button type="primary" :loading="buyLoading" @click="confirmBuy">确认购买</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      issueNumber: null, // 当前查询期号
      chaoshi: {
        preType: 0,
        type: 0,
        pageNum: 1,
        pageSize: 10,
        preNumber: null,
        total: 0,
      },
      chaoshi_tableData: [],
      chaoshiLoading: false,
      buyDialog: {
        show: false,
        title: '实战方案购买',
        row: null,
      },
      buyLoading: false,
    }
  },
  mounted() {
    this.getSchemeList();
  },
  methods: {
    goBack() {
      this.$router.push('/sttzzbfzx');
    },
    // 我的购买
    goMyPurchase() {
      this.$router.push('/sttzzbfzx/market/my/purchase');
    },
    // 我发布的
    goMyOffering() {
      this.$router.push('/sttzzbfzx/market/my/offering');
    },
    // 销售总览
    goMySold() {
      this.$router.push('/sttzzbfzx/market/my/sold');
    },
    // 实战超市大厅列表：GET /stage-api/assist/market/scheme/list
    // 参数即 this.chaoshi 整体：preType(彩种) / type(期数:0最新/1上一/2下一) / pageNum / pageSize / preNumber(期号)
    getSchemeList() {
      this.chaoshiLoading = true
      this.$http.get('/stage-api/assist/market/scheme/list', {
        params: this.chaoshi
      }).then(res => {
        this.issueNumber = res.lastNumber
        this.chaoshi_tableData = res.marketInfos.rows || []
        this.chaoshi.total = res.marketInfos.total || 0
      }).catch(() => {
        this.chaoshi_tableData = []
        this.chaoshi.total = 0
      }).finally(() => {
        this.chaoshiLoading = false
      })
    },
    // 切换彩种（双色球/大乐透）：重置分页后重新拉取
    switchChaoshiLottery(type) {
      this.chaoshi.preType = type
      this.chaoshi.pageNum = 1
      this.getSchemeList()
    },
    // 切换期数类型（最新期/上一期/下一期）：期号由后端按 type 定位，前端传当前 issueNumber 作为参考
    switchChaoshiPeriod(type) {
      this.chaoshi.type = type
      this.chaoshi.pageNum = 1
      this.chaoshi.preNumber = this.issueNumber
      this.getSchemeList()
    },
    // 翻页
    onChaoshiPage(page) {
      this.chaoshi.pageNum = page
      this.getSchemeList()
    },
    // 点击购买：打开购买弹窗
    chaoshiItemBuy(item) {
      this.openBuyDialog(item)
    },
    // 点击下载：走统一下载
    chaoshiItemDownload(item) {
      this.download(item)
    },
    // 打开购买弹窗
    openBuyDialog(row) {
      this.buyDialog.row = row
      this.buyDialog.title = (row.teamName || '实战方案') + ' - 购买'
      this.buyDialog.show = true
    },
    // 确认购买
    confirmBuy() {
      const row = this.buyDialog.row
      if (!row) return
      this.buyLoading = true
      this.$http.get('/stage-api/assist/market/scheme/download', {
        params: { marketId: row.id },
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success('购买成功')
          this.buyDialog.show = false
        } else {
          this.$message.error(res.msg || '购买失败')
        }
      }).catch(() => { }).finally(() => {
        this.buyLoading = false
        this.getSchemeList()
      })
    },
    // 下载方案：item.schemeFilePath 为文件相对路径，补上前缀后触发当前页下载（不跳页）
    download(item) {
      const path = item && item.schemeFilePath
      if (!path) {
        this.$message.warning('该方案暂无可下载文件')
        return
      }
      const url = this.$img(path)
      const fileName = String(path).split('/').pop() || '方案文件'
      this.$message.info('正在准备下载…')
      this.$http.get(url, { responseType: 'blob' })
        .then(res => {
          const blob = (res && res instanceof Blob) ? res : (res && res.data)
          if (!blob) {
            this.$message.error('下载失败：未获取到文件')
            return
          }
          const blobUrl = URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = blobUrl
          a.download = fileName
          a.style.display = 'none'
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          setTimeout(() => URL.revokeObjectURL(blobUrl), 1000)
        })
        .catch(() => {
          this.$message.error('下载失败，请检查登录状态或网络后重试')
        })
    },
  }
}
</script>

<style lang="scss" scoped>
.zhaogu-page {
  background: #ffffff;
  padding: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border-radius: 8px;

  .page-bar {
    margin-bottom: 10px;
    position: absolute;
  }

  .back-btn {
    display: inline-block;
    cursor: pointer;
    color: #347caf;
    font-size: 14px;
    padding: 6px 14px;
    border: 1px solid #347caf;
    border-radius: 5px;
    transition: all 0.2s;

    &:hover {
      background-color: #347caf;
      color: #ffffff;
    }
  }

  .page-title {
    font-size: 22px;
    font-weight: bold;
    color: #347caf;
    text-align: center;
    padding: 10px 0 20px;
    border-bottom: 2px solid #347caf;
    margin-bottom: 20px;
  }

  .market-entry {
    display: flex;
    gap: 12px;
    margin-bottom: 16px;

    .entry-btn {
      background: linear-gradient(135deg, #347caf 0%, #4a9bd6 100%);
      color: #ffffff;
      padding: 7px 18px;
      border-radius: 7px;
      font-size: 14px;
      font-weight: bold;
      cursor: pointer;
      box-shadow: 0 3px 10px rgba(52, 124, 175, 0.3);
      transition: all 0.2s;

      &:hover {
        opacity: 0.9;
        box-shadow: 0 4px 14px rgba(52, 124, 175, 0.45);
      }
    }
  }
}

// 彩种切换条（与 zhaogu 同款浅蓝渐变卡片）
.lottery {
  display: flex;
  align-items: center;
  border: 1px solid #e4e7ed;
  border-radius: 10px;
  background: linear-gradient(135deg, #f5faff 0%, #eaf2fa 100%);
  padding: 8px;
  position: relative;

  span {
    flex: 0 0 auto;
    background-color: #ffffff;
    color: #347caf;
    padding: 12px 46px;
    margin-right: 8px;
    display: inline-block;
    cursor: pointer;
    border-radius: 7px;
    font-size: 15px;
    font-weight: bold;
    border: 1px solid transparent;
    transition: all 0.2s;

    &:hover {
      color: #2a6490;
      background-color: #eef5fb;
    }

    &.active {
      background: linear-gradient(135deg, #347caf 0%, #4a9bd6 100%);
      color: #ffffff;
      box-shadow: 0 3px 10px rgba(52, 124, 175, 0.35);
    }
  }

  .msg {
    margin-left: auto;
    color: #c0392b;
    font-weight: bold;
    font-size: 16px;
    letter-spacing: 1px;
    padding-right: 14px;
    position: relative;

    &::before {
      content: "";
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: #c0392b;
      margin-right: 8px;
      vertical-align: middle;
    }
  }
}

// 须知 + 申请帮扶按钮（与 zhaogu 同款）
.sub {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 18px 22px;
  border: 1px solid #e4e7ed;
  border-radius: 10px;
  background: linear-gradient(135deg, #f5faff 0%, #eaf2fa 100%);
  margin-top: 14px;
  position: relative;

  >div {
    flex: 1;

    >span {
      display: inline-block;
      color: #347caf;
      font-size: 17px;
      font-weight: bold;
      margin-bottom: 8px;
    }
  }

  span {

    &.btn {
      flex: 0 0 auto;
      background: linear-gradient(135deg, #347caf 0%, #4a9bd6 100%);
      color: #ffffff;
      padding: 9px 18px;
      border-radius: 7px;
      font-size: 14px;
      font-weight: bold;
      cursor: pointer;
      box-shadow: 0 3px 10px rgba(52, 124, 175, 0.3);
      transition: all 0.2s;

      &:hover {
        opacity: 0.9;
        box-shadow: 0 4px 14px rgba(52, 124, 175, 0.45);
      }
    }
  }

  .msg {
    display: flex;
    flex-wrap: wrap;
    gap: 6px 24px;
    margin-top: 6px;

    span {
      color: #e67e22;
      font-size: 13px;
      position: relative;
      padding-left: 14px;

      &::before {
        content: "•";
        position: absolute;
        left: 0;
        color: #e67e22;
      }
    }
  }
}

// 期号切换条（与 zhaogu 同款边框布局）
.tit {
  border: 1px solid rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 14px;

  >div {
    display: flex;
    align-items: center;
    margin: 0 20px;

    h3 {
      color: #347caf;
    }

    &.btn {
      background-color: #347caf;
      color: #ffffff;
      padding: 5px 10px;
      border-radius: 5px;
    }

    >div {
      margin-left: 20px;

      span {
        background-color: #dbdbdb;
        padding: 5px 10px;
        border-radius: 5px;
        margin-right: 20px;
        cursor: pointer;

        &.active {
          background-color: #93d2f3;
        }
      }
    }
  }
}

.tableMsg {
  margin-top: 10px;
  text-align: center;
  color: #898af7;
  font-weight: bold;
}

// 分页条（与 zhaogu 同款两端占位）
.fenye {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .zhanwei {
    width: 25%;
  }
}

// 实战方案购买信息块
.buy-info {
  padding: 8px 4px;

  .buy-row {
    display: flex;
    align-items: center;
    padding: 10px 12px;
    border-bottom: 1px solid #f0f2f5;

    &:last-child {
      border-bottom: none;
    }
  }

  .buy-label {
    width: 130px;
    flex-shrink: 0;
    color: #6b7c93;
    font-size: 14px;
  }

  .buy-value {
    flex: 1;
    color: #303133;
    font-size: 14px;
    word-break: break-all;
  }
}

::v-deep .el-table th {
  background-color: #eef4ff;
  color: #1565d8;
  font-weight: bold;

  .cell {
    text-align: center;
  }
}

::v-deep .el-table td,
::v-deep .el-table th.is-leaf {
  border-bottom: 1px solid rgba(21, 101, 216, 0.12);
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover>td {
  background-color: #f5f9ff;
}
</style>
